import { type NotifyOnChangeProps, useQuery } from '@tanstack/react-query';

import type { FeatureFlag } from 'constants/features';

import { featureFlags } from 'services/featureFlags/featureFlags';
import { isTestEnvironment } from 'utils/environment/environment';

type Options = {
  enabled?: boolean;
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
  refetchInterval?: number | false;
};

const defaultOptions: Options = {
  enabled: true,
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchInterval: false,
};

export const usePeertransferFlags = (
  flagOrFlags: FeatureFlag[] | FeatureFlag,
  options: Options = {},
) => {
  const flags = Array.isArray(flagOrFlags) ? flagOrFlags : [flagOrFlags];

  return useQuery({
    queryKey: ['flags', ...flags],
    queryFn: (): Promise<Record<FeatureFlag, boolean>> => {
      return featureFlags.fetch(flags, false);
    },
    ...defaultOptions,
    ...options,
    staleTime: isTestEnvironment()
      ? 0
      : (options.staleTime ?? defaultOptions.staleTime),
    notifyOnChangeProps: ['data', 'error'] as NotifyOnChangeProps,
  });
};
